/* eslint-disable max-len */
export const VISIT_PRO_DESK = 'Please visit your local Pro Desk or call our Pro Support Team to discuss pricing and availability.';
export const HOME_DEPOT_QUOTE_CENTER = 'HDQC';
